import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
	className?: string;
	showLabel?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
	className = '',
	showLabel = false
}) => {
	const { theme, toggleTheme } = useTheme();

	return (
		<button
			onClick={toggleTheme}
			className={`
        p-2 text-gray-600 dark:text-gray-300 
        hover:text-gray-900 dark:hover:text-white 
        rounded-md
        ${className}
      `}
			title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
		>
			{theme === 'light' ? (
				<Moon className="w-5 h-5" />
			) : (
				<Sun className="w-5 h-5" />
			)}
			{showLabel && (
				<span className="ml-2 text-sm">
					{theme === 'light' ? 'Dark' : 'Light'} Mode
				</span>
			)}
		</button>
	);
};
